<template>
  <div>
    <div class="title-valid-button">Exemple de récapitulatif généré automatiquement (<b>L'indication des tarifs avec les mentions HT et TTC ne se fait que si l'option a été configurée</b>)</div>
    <div class="text-start">
      <p>Votre structure : Nom de la structure</p>
    <p>Vos offres : <br>
    - Nom de l'offre choisie - (quantité: X, prix unitaire: X€) <br>
      ...
    </p>
      <p>
        Vos options: <br>
        - Nom de l'option choisie - (quantité: X, prix unitaire: X€) <br>
        ...
      </p>
      <p>
        Vos options (facturées plus tard):
        - Nom de l'option choisie - (quantité: X, prix unitaire: X€) <br>
        ...
      </p>
      <p>Montant total: X€</p>
      <p>
        Moyen de paiement choisi: Moyen de paiement <br>
        Instruction de paiement : <br>
        Moyen de paiement : instruction de paiement définie pour ce moyen de paiement
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdhSummaryExample",
}
</script>